<template>
    <div>
        <v-list-item
            class="py-1"
            :to="{ name: 'teacher', params: { id: teacher.id } }"
            v-ripple="phoneOnly ? { class: 'ripple--color' } : false"
        >
            <v-list-item-avatar size="64" class="bordered">
                <v-img :src="teacher.avatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="strong-text--text medium-text">{{ teacher.name }}</v-list-item-title>
                <v-list-item-subtitle>
                    <v-chip label small style="height: 22px;" outlined class="pe-2">
                        <v-icon left>mdi-play-box-multiple</v-icon>
                        {{ unitFormat(teacher.courses_count, 'دورة', 'دورتين', 'دورات') }}
                    </v-chip>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="my-auto ms-2">
                <v-icon size="20" color="grey">mdi-chevron-left</v-icon>
            </v-list-item-icon>
        </v-list-item>
        <v-divider v-if="divider" inset style="opacity: 0.6"></v-divider>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        teacher: {
            type: Object,
            required: true,
        },
        divider: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,
    },
};
</script>
